import './Headers.scss'

export default () => {
    return <div className="header-small panel">
        <h1>Murder Party</h1>
        <h5>by Pazka</h5>
    </div>
}